import { Text, Box, Flex, Divider } from '@chakra-ui/react';

const ThroughputLimit = ({ entitlement }) => {
  return (
    <Flex direction="column" h="100%">
      <Text textStyle="bodyFamilySemiBold" fontSize="18px">
        {entitlement.name}
      </Text>
      <Divider border="1px solid lightGrey" mt={2} />
      <Flex
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={6}
      >
        <Text textStyle="heading3">{entitlement.limitValue} requests</Text>
        <Text textStyle="bodySmall" fontSize="14px" color="#979797">
          per second
        </Text>
      </Flex>
    </Flex>
  );
};

export default ThroughputLimit;
